import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "jds_heart",
  "use": "jds_heart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"jds_heart\">\n  <path fill-rule=\"evenodd\" d=\"M8.411 5.011a4 4 0 0 0-3.214 6.844l.007.006L12 18.593l6.796-6.732a1 1 0 0 1 .064-.058 4 4 0 1 0-6.06-5.196 1 1 0 0 1-1.603-.004A4 4 0 0 0 8.411 5.01Zm11.723 8.34-7.43 7.36a1 1 0 0 1-1.408 0L3.8 13.285a6 6 0 0 1 8.205-8.754 6.002 6.002 0 0 1 7.946-.034 6 6 0 0 1 .25 8.793.967.967 0 0 1-.066.06Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol